// Ulaz iz mobilne aplikacije (WebView): /placanje/m/{merchantPaymentId} nema
// redux istoriju kupovine, pa se bookingResult rekonstruiše iz suženog
// GET /status DTO-a — tačno onoliko koliko PaymentPage koristi.

const PAYABLE_STATUSES = ["RESERVED", "PAYMENT_SESSION_REQUESTED"];

export function bookingResultFromStatus(dto, now = Date.now()) {
    if (!dto?.merchantPaymentId) return null;
    if (!PAYABLE_STATUSES.includes(dto.status)) return null;

    const ticketIds = dto.reservation?.ticketIds || [];
    const grossPara = dto.amount?.grossPara;
    if (ticketIds.length === 0 || typeof grossPara !== "number") return null;

    const expiresAt = Date.parse(dto.reservation?.reservationValidDt || "");
    const remainingSeconds = Number.isFinite(expiresAt)
        ? Math.max(0, Math.floor((expiresAt - now) / 1000))
        : 0;
    if (remainingSeconds <= 0) return null;

    return {
        merchantPaymentId: dto.merchantPaymentId,
        ticketIds,
        // šema drži pare; PaymentPage računa u decimalnom RSD
        amount: grossPara / 100,
        reservedAt: now,
        ttlSeconds: remainingSeconds,
        // Ovaj tok opslužuje samo WebView iz aplikacije. Vrednost ide na fiskalni
        // račun i u `ticket.cashier`, pa mora biti i u `notifications.*.cashiers`.
        cashier: "BusGo Mobile",
        customer: { email: null },
    };
}
